module.exports = __webpack_public_path__ + "img/Cigar.7b3c65c7.jpg";